import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import { login } from "../../redux/userSlice";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    if (email === "" || password === "") {
      console.log("err");
      return;
    }

    fetch(
      "https://shreyas-dobby-backend-production.up.railway.app/api/auth/login",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: email,
          password: password,
        }),
      }
    )
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        // console.log(result);
        dispatch(
          login({
            token: result.token,
            userId: result.userId,
            message: result.message,
            loggedIn: true,
          })
        );

        localStorage.setItem("token", result.token);
        localStorage.setItem("userId", result.userId);

        navigate("/");
      })
      .catch((err) => console.log(err));
  };

  return (
    <div className="flex justify-center flex-col p-10 items-center">
      <h1 className="my-4 text-4xl font-bold">Login</h1>
      <form>
        <div className="flex flex-col p-6 bg-gray-400 rounded-md">
          <p className="my-2">E-mail</p>
          <input
            type="email"
            name="email"
            placeholder="email"
            className="rounded-sm p-2 outline-none"
            onChange={(e) => {
              setEmail(e.target.value);
            }}
          />
          <p className="my-2">Password</p>
          <input
            type="password"
            name="password"
            placeholder="email"
            className="rounded-sm p-2 outline-none"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
          />
          <button
            onClick={handleSubmit}
            type="submit"
            className="mt-10 bg-blue-700 p-3 rounded-md hover:opacity-70 transition-all 
            duration-300 ease-in"
          >
            Login
          </button>
        </div>
      </form>
      <div className="mt-10">
        <p className="">
          <Link to="/signup" className="">
            New to this website? Sign Up!
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
